import { ChatChannelType, type IChatConversation } from 'src/@types/chat';
import { useAuthContext } from 'src/auth/useAuthContext';
import { useSelector } from 'src/redux/store';
import { isChatChannelHidden } from '../utils/isChatChannelHidden';

export const useChatChannelsOfType = ({
  type,
  p2p,
  includeHidden = false,
}: {
  type: ChatChannelType;
  p2p?: boolean;
  includeHidden?: boolean;
}) => {
  const { user } = useAuthContext();

  const channels = useSelector((state) => {
    const { allIds, byId } = state.chat.conversations;

    if (!allIds.length) return [];

    return allIds.reduce((acc, id) => {
      const item = byId?.[id];
      if (!item) return acc;

      const isType = item.type === type && (p2p ? item.p2p : !item.p2p);

      const isHidden = isChatChannelHidden(item, user!._id);

      if (isType && (includeHidden || !isHidden)) {
        const unreadCount = item.unreadMessages?.length;
        return [...acc, { ...item, unreadCount }];
      }

      return acc;
    }, [] as IChatConversation[]);
  });

  return channels;
};
